const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const sendPersonalForm = async (userId = null, name, selectedCountry, phone, email, message, sale, category, contact, line, wechat, budget, room, purpose, area, landUnit) => {

    const data = {
        userId,
        name,
        phonePrefix: selectedCountry,
        phone,
        email,
        message,
        sale,
        category: category.value,
        preferredContact: contact.value,
        line,
        wechat,
        budget,
        rooms: room.value,
        purpose,
        area,
        landUnit: landUnit.value
    };


    const url = `${baseUrl}/enquiry/personalizedservice`

    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'Content-Type': 'application/json'
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        cache: 'no-store',
        body: JSON.stringify(data)
    })

    const result = await response.json()
    return result

}
